import { DropdownSelect, FormField } from '@zillow/constellation-10';
import { TIME_FRAME_DROPDOWN_OPTIONS } from '.';

export const TimeFrameDropdownSkeleton = () => {
  return (
    <FormField
      css={{
        minWidth: '309px',
      }}
      control={
        <DropdownSelect
          disabled={true}
          defaultValue=""
          onOptionSelect={() => null}
          options={TIME_FRAME_DROPDOWN_OPTIONS}
          placeholder="Select time frame..."
          shouldAwaitInteractionResponse
          size="lg"
          css={{
            backgroundColor: 'bg.action.neutral.default',
          }}
        />
      }
    />
  );
};
